import React from "react";
import "./header.css";
// import CV from '../../assets/CV.pdf'
import ME from "../../assets/me.png";
import HeaderSocials from "./HeaderSocials";
const Header = () => {
  return (
    <header id="home">
      <div className="container header__container">
        <h5>Hello I'm</h5>
        <h1>Saransh Gangwar</h1>
        <h4>Software Developer</h4>
        <p
          style={{
            fontWeight: 300,
            marginTop: "1rem",
          }}
          className="text-light"
        >
          I am a software developer from India, currently working at{" "}
          <a
            href="https://in.linkedin.com/company/infinitelocus"
            target="_blank"
            rel="noreferrer"
          >
            Infinite Locus
          </a>
          . I have completed my{" "}
          <span color="#fff">B.Tech in computer science and engineering</span>{" "}
          from{" "}
          <a href="https://hbtu.ac.in/" target="_blank" rel="noreferrer">
            Harcourt Butler Technical University
          </a>
        </p>
        <center>
          <div className="me">
            <img src={ME} alt="Me" />
          </div>
        </center>

        {/* <div className='cta'>
          <a href={CV} download className='btn'>Download CV</a>
          <a href='#contact' className='btn btn-primary'>Let's Talk</a>
        </div> */}

        <HeaderSocials />
        <a href="#contact" className="scroll__down">
          Scroll Down
        </a>
      </div>
    </header>
  );
};

export default Header;
